import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const MODEL: AppRouteRecordRaw = {
  path: '/model',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '模型管理',
    requiresAuth: true,
    icon: 'icon-dashboard',
    order: 30
  },
  children: [
    {
      path: 'list',
      component: () => {
        return import('@/views/model/list/page.vue');
      },
      meta: {
        locale: '模型列表',
        icon: 'icon-layers'
      }
    },
    {
      path: ':type/:id',
      component: () => {
        return import('@/views/model/add/page.vue');
      },
      meta: {
        locale: path => {
          return path.includes('edit') ? '编辑模型' : '添加模型';
        },
        ignoreCache: true,
        hideInMenu: true
      }
    }
  ]
};

export default MODEL;
